import React from 'react';

const hcStyles = `
  .hc-card {
    background: #0f1c2e;
    border-radius: 20px; padding: 1.5rem;
    position: relative; overflow: hidden;
    text-align: center;
  }
  .hc-blob {
    position: absolute; width: 180px; height: 180px; border-radius: 50%;
    background: radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%);
    bottom: -40px; right: -40px; pointer-events: none;
  }
  .hc-inner { position: relative; z-index: 1; }
  .hc-title { font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 4px; }
  .hc-sub { font-size: 12px; color: rgba(255,255,255,0.5); margin-bottom: 1.25rem; }
  .hc-phone-btn {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    background: #F97316; color: #fff; border: none; border-radius: 12px;
    padding: 11px 16px; width: 100%; margin-bottom: 10px;
    font-family: 'Sora', sans-serif;
    font-size: 14px; font-weight: 600; cursor: pointer;
    text-decoration: none;
    box-shadow: 0 3px 14px rgba(249,115,22,0.35);
    transition: background 0.15s;
  }
  .hc-phone-btn:hover { background: #ea6a0a; color: #fff; text-decoration: none; }
  .hc-phone-btn svg { width: 16px; height: 16px; }
  .hc-email { font-size: 12px; color: rgba(255,255,255,0.45); margin-top: 6px; }
  .hc-divider { font-size: 11px; color: rgba(255,255,255,0.25); margin: 8px 0; }
`;

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 13.5 19.79 19.79 0 0 1 1 4.82 2 2 0 0 1 2.98 2.63h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 10.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 18"/>
  </svg>
);

export default function HelpCenter() {
  return (
    <div className="hc-card">
      <style>{hcStyles}</style>
      <div className="hc-blob" />
      <div className="hc-inner">
        <div className="hc-title">Need assistance?</div>
        <div className="hc-sub">Our support team is ready to help you anytime.</div>
        <a href="tel:+918049368211" className="hc-phone-btn">
          <IconPhone /> +91 8049368211
        </a>
        <div className="hc-divider">or reach us at</div>
        <div className="hc-email">care@b4salary.com</div>
      </div>
    </div>
  );
}
